import { parse } from '@sequencehq/utils/dates'
import { getScheduleDates } from '@sequencehq/utils'
import { useMemo } from 'react'
import { AmendableSchedule } from './useAmendableSchedules'

const API_DATE_FORMAT = 'yyyy-MM-dd'

const parseApiDate = (date: string) => parse(date, API_DATE_FORMAT, new Date())

const parseApiEndDate = (date: string | undefined) =>
  date ? parseApiDate(date) : undefined

export const useSelectedScheduleDates = (
  schedule: AmendableSchedule | undefined
) =>
  useMemo(() => {
    if (!schedule) {
      return {
        scheduleDates: {
          startDate: undefined,
          endDate: undefined,
          nextBillingDate: undefined
        },
        hasFuturePhases: undefined
      }
    }

    const startDate = parseApiDate(schedule.startDate)
    const endDate = parseApiEndDate(schedule.endDate)

    const { nextBillingDate, hasFuturePhases } = getScheduleDates({
      startDate,
      endDate,
      recurrenceDayOfMonth: schedule.recurrenceDayOfMonth,
      phases: schedule.phases.map(phase => ({
        startDate: parseApiDate(phase.startDate),
        endDate: parseApiEndDate(phase.endDate),
        recurrencePreference: phase.recurrencePreference
      })),
      prices: schedule.prices
    })

    return {
      scheduleDates: { startDate, endDate, nextBillingDate },
      hasFuturePhases
    }
  }, [schedule])
